import React from "react";
import { Info } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

// v0.5.2 — compact "i in a circle" info affordance. Replaces verbose
// inline help/subtitle prose with a small icon that reveals the same
// text in a popover on click, reducing on-screen clutter. Works on
// touch + keyboard (click-based, not hover-only).
export const InfoHint = ({ label, children, side = "top", align = "start", testid = "info-hint", className = "" }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={testid}
        aria-label={typeof label === "string" ? label : "More information"}
        onClick={(e) => e.stopPropagation()}
        className={`inline-flex items-center justify-center align-middle text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 transition-colors ${className}`}
      >
        <Info size={14} weight="bold" />
      </button>
    </PopoverTrigger>
    <PopoverContent
      side={side}
      align={align}
      data-testid={`${testid}-popover`}
      className="w-72 bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 text-xs text-slate-700 dark:text-slate-200 leading-relaxed"
    >
      {children || label}
    </PopoverContent>
  </Popover>
);

export default InfoHint;
